import { render, staticRenderFns } from "./KpiMcrApproval.vue?vue&type=template&id=55c857f8"
import script from "./KpiMcrApproval.vue?vue&type=script&lang=js"
export * from "./KpiMcrApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports